(() => {
    const KEY = 'collectionCols';
    const MOBILE_BREAKPOINT = 1024;

    // 현재 화면 크기 체크 (더 정확하게)
    const isMobile = () => {
        return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
    };

    // 저장된 설정 가져오기
    const getCols = () => {
        const storageKey = isMobile() ? `${KEY}_mobile` : `${KEY}_desktop`;
        const savedValue = localStorage.getItem(storageKey);

        // 저장된 값이 없으면 기본값 반환
        if (!savedValue) {
            return isMobile() ? '1' : '3';
        }

        // 모바일에서 유효한 값인지 체크
        if (isMobile() && !['1', '2', '4'].includes(savedValue)) {
            return '1';
        }

        // 데스크탑에서 유효한 값인지 체크
        if (!isMobile() && !['3', '4', '6'].includes(savedValue)) {
            return '3';
        }

        return savedValue;
    };

    // 설정 적용
    const apply = (cols) => {
        // cols가 없으면 getCols() 호출
        if (!cols) {
            cols = getCols();
        }

        const grid = document.querySelector('#product-grid');
        if (grid) {
            grid.setAttribute('data-cols', cols);
            console.log('Applied cols:', cols, 'Mobile:', isMobile()); // 디버깅용
        }

        // 버튼 활성화 상태 업데이트
        document.querySelectorAll('#col-view .col-view-item').forEach(btn => {
            btn.classList.toggle('is-active', btn.dataset.cols === cols);
            btn.setAttribute('aria-pressed', btn.dataset.cols === cols ? 'true' : 'false');
        });

        // 저장
        try {
            const storageKey = isMobile() ? `${KEY}_mobile` : `${KEY}_desktop`;
            localStorage.setItem(storageKey, cols);
        } catch(e) {
            console.error('localStorage error:', e);
        }
    };

    // 버튼 세트 업데이트
    const updateButtons = () => {
        const wrapper = document.querySelector('#col-view');
        if (!wrapper) return;

        const buttons = isMobile()
            ? [
                { cols: '1', text: '1' },
                { cols: '2', text: '2' },
                { cols: '4', text: '4' }
            ]
            : [
                { cols: '3', text: '3' },
                { cols: '4', text: '4' },
                { cols: '6', text: '6' }
            ];

        // 버튼 HTML 재생성
        wrapper.innerHTML = buttons.map(({ cols, text }) =>
            `<button class="col-view-item btn" data-cols="${cols}" aria-pressed="false" type="button">${text}</button>`
        ).join('');

        // 재적용 (getCols()로 현재 값 가져옴)
        apply(getCols());
    };

    // 이벤트 리스너
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('#col-view .col-view-item');
        if (!btn) return;
        apply(btn.dataset.cols);
    });

    // 리사이즈 처리
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            updateButtons();
        }, 250);
    });

    // 초기 실행
    const init = () => {
        updateButtons();
    };

    // DOM 준비 후 실행
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        // 약간의 딜레이를 줘서 모바일에서 확실히 실행되도록
        setTimeout(init, 100);
    }

    // Shopify 이벤트 대응
    ['shopify:section:load', 'shopify:section:unload', 'facets:updated'].forEach(event => {
        document.addEventListener(event, () => apply(getCols()));
    });

    // DOM 변경 감지
    const observer = new MutationObserver(() => {
        const grid = document.querySelector('#product-grid');
        if (grid && !grid.hasAttribute('data-cols')) {
            apply(getCols());
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
})();